import { Outlet } from "react-router";

const MembershipSetupIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default MembershipSetupIndexPage;
